import * as Type from 'store/actionTypes/productModel'

const initialStateWithoutData = {
  isLoading: false,
  isError: false,
  message: [],
}

const initialState = {
  ...initialStateWithoutData,
  data: {
    data: [], 
    page: 0, 
    pageSize: 10, 
    totalPage: 0
  },
  dataDetail: {},
}

const request = state => ({
  ...state,
  ...initialStateWithoutData,
  isLoading: true,
})

const requestError = (state, payload) => ({
  ...state,
  isLoading: false,
  isError: true,
  message: payload,
})


const getProductModelSuccess = (state, payload) => ({
  ...state,
  isLoading: false,
  isError: false,
  data: payload,
})

const getProductModelDetailSuccess = (state, payload) => ({
  ...state,
  isLoading: false,
  isError: false,
  dataDetail: payload,
})

const createProductModelSuccess = (state, payload) => ({
  ...state,
  isLoading: false,
  isError: false,
  message: payload,
})

const updateProductModelSuccess = (state, payload) => ({
  ...state,
  isLoading: false,
  isError: false,
  message: payload,
})

const deleteProductModelSuccess = (state, payload) => ({
  ...state,
  isLoading: false,
  isError: false,
  message: payload,
})


const productModelReducer = (state = initialState, action) => {
  switch (action.type) {
    case Type.PRODUCT_MODEL_REQUEST: return request(state)
    case Type.PRODUCT_MODEL_REQUEST_CUD: return request(state)

    case Type.GET_PRODUCT_MODEL_SUCCESS: return getProductModelSuccess(state, action.payload)
    case Type.GET_PRODUCT_MODEL_ERROR: return requestError(state, action.payload)

    case Type.GET_PRODUCT_MODEL_DETAIL_SUCCESS: return getProductModelDetailSuccess(state, action.payload)
    case Type.GET_PRODUCT_MODEL_DETAIL_ERROR: return requestError(state, action.payload)

    case Type.CREATE_PRODUCT_MODEL_SUCCESS: return createProductModelSuccess(state, action.payload)
    case Type.CREATE_PRODUCT_MODEL_ERROR: return requestError(state, action.payload)

    case Type.UPDATE_PRODUCT_MODEL_SUCCESS: return updateProductModelSuccess(state, action.payload)
    case Type.UPDATE_PRODUCT_MODEL_ERROR: return requestError(state, action.payload)

    case Type.DELETE_PRODUCT_MODEL_SUCCESS: return deleteProductModelSuccess(state, action.payload)
    case Type.DELETE_PRODUCT_MODEL_ERROR: return requestError(state, action.payload)
    default:
      return state
  }
}

export default productModelReducer
